/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import type AppService from 'embercom/services/app-service';
import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';

interface Signature {
  Args: {
    Positional: [string[]];
  };
  Return: boolean;
}

export default class PermissionsHierarchyHasVisiblePermissions extends Helper<Signature> {
  @service declare permissionsHierarchyService: $TSFixMe;
  @service declare appService: AppService;

  compute([permissionKeys]: [string[]]): boolean {
    return permissionKeys.some((key) => {
      let permission = this.permissionsHierarchyService.permissionsHierarchy[key];
      if (!permission) {
        return false;
      }
      let featureFlag = permission['feature_flag'];
      return isEmpty(featureFlag) || this.appService.app.canUseFeature(featureFlag);
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'permissions-hierarchy-has-visible-permissions': typeof PermissionsHierarchyHasVisiblePermissions;
  }
}
